<template>
  <div class="ndetails">
    <div class="details litigation-details">
      <a-spin :spinning="loading">
        <div class="maindetails">
          <!-- <a-button class='debdel' @click='debDel($route.params.id)'
            v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:del")'>删除</a-button> -->
          <div class="classcard">
            <!-- <div style="display: flex;justify-content: space-between;align-items: center;"> -->
            <!-- <div class="radio-inputs">
              <label class="radio" v-for='(item, index) in caselist' :key='item.id'>
                <input type="radio" name="radio" :checked="index === selectedIndex"
                  @click="switchChange(item, index)" />
                <span class="name">
                  {{ item.cause_type == 1 ? `案件 ${item.sort} ( 诉讼 )` : `案件 ${item.sort} ( 仲裁 )` }}
                  <span v-if="index === selectedIndex" class="line-effect"></span>
                  <span v-if="index === selectedIndex" class="particle-top"></span>
                  <span v-if="index === selectedIndex" class="particle-bottom"></span>
                </span>
              </label>
            </div> -->
            <!-- <div class="rt">
                <a-button type="danger" @click='delsu(1)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "cause:invaild") && $store.state.cause.invaild != 1 && caselist.length > 0'>
                  作废
                </a-button>
                <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delsu(0)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "cause:delete") && debInfo.is_clear != 1 && caselist.length > 0'>
                  <a-button type="danger" style="background:#A4B5C7;border-color:#A4B5C7;margin-right: 20px;">
                    删除
                  </a-button>
                </a-popconfirm>
              </div>
              </div> -->
            <div>
              <!-- <a-button type="primary" icon="plus" @click='deAdd'
                v-if='$common.AccAUTH(debInfo.accuser_id, "cause:add") && debInfo.is_clear != 1'>新增</a-button>
              <a-button style="width: 120px;margin: 0 10px;" icon="paper-clip" @click='seeFile(0)'
                v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:files")'>附件汇总 </a-button>
              <a-button style="width: 120px;" icon="file-protect" @click='visibleShow("CauseStepLog")'
                v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:keep:index")'>操作记录 </a-button>
              <a-button style="margin: 0 10px;" type="danger" @click='delsu(1)'
                v-if='$common.AccAUTH(debInfo.accuser_id, "cause:invaild") && $store.state.cause.invaild != 1 && caselist.length > 0'>
                作废
              </a-button> -->
              <!-- <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delsu(0)'
                v-if='$common.AccAUTH(debInfo.accuser_id, "cause:delete") && debInfo.is_clear != 1 && caselist.length > 0'>
                <a-button type="danger" style="background:#A4B5C7;border-color:#A4B5C7;margin-right: 10px;">
                  删除
                </a-button>
              </a-popconfirm> -->
            </div>
          </div>
          <!-- <a-button class='debdel' type="primary" @click='visibleShow("globalModal")'>全局管理</a-button> -->
          <globalModal ref="globalModal" :caselist="caselist"></globalModal>
          <div class="dislogbox">
            <File ref='filelist' v-if='dislog.filelist' :type="FileType"></File>
            <!-- 基本信息附件 -->
            <FileHistory :List='debInfo.keep' ref='FileHistory' :clear='debInfo.is_clear' v-if='dislog.FileHistory'>
            </FileHistory>
            <!--保全记录 -->
            <Call ref='call' v-if='dislog.call' :clear='debInfo.is_clear'></Call>
            <!-- 催收记录 -->
            <Laysuit :cause_reason='cause_reason' ref='Laysuit' :info='LaysuitInfo' :accuserList='LaysuitaccuserList'
              :alldefendantList="alldefendantList" :bankList="bankList || []"></Laysuit>
            <!-- 案件 -->
            <StepSel :Step='Step' ref='stepbox' :Arr="arr" :hasjdList="hasjdList" :causeType="i.cause_type"
              @lite='(element) => { $store.dispatch("setkey", { key: "Edit", value: false }); visibleShow(element) }'>
            </StepSel>
            <paymentCard rfe="paymentPopUp" v-if="dislog.paymentPopUp"></paymentCard>
            <Beforetime ref='beforetime' v-if='dislog.beforetime'></Beforetime>
            <Beforestart ref='beforestart' v-if='dislog.beforestart'></Beforestart>
            <Police ref='police' :agentmodelList="agentmodelList" :costmodelList="costmodelList" v-if='dislog.police'>
            </Police>
            <Ones ref='ones' :agentmodelList="agentmodelList" :costmodelList="costmodelList" v-if='dislog.ones'></Ones>
            <!--一审立案审查中  二审立案审查-->
            <preservation ref='preservation' :preservates="preservates" v-if='dislog.preservation'></preservation>
            <Twos ref='twos' v-if='dislog.twos'></Twos><!-- 诉前诉中调解、执行和解 -->
            <Three ref='three' v-if='dislog.three'></Three><!-- 一审立案  二审立案 执行立案 -->
            <Four ref='Fours' v-if='dislog.Fours'></Four><!-- 一审待开庭 二审待开庭 -->
            <Five ref='Five' :agentmodelList="agentmodelList" :costmodelList="costmodelList" v-if='dislog.Five'></Five>
            <!-- 一审待判决 二审待判决 -->
            <Six ref='Six' v-if='dislog.Six'></Six><!-- 判决文书 二审裁决书-->
            <Fiveteen ref='Fiveteen' :agentmodelList="agentmodelList" :costmodelList="costmodelList"
              v-if='dislog.Fiveteen'></Fiveteen> <!-- 执行中 -->
            <Reason ref='reason' v-if='dislog.reason'></Reason> <!-- 作废原因 -->
            <!-- <OtherType ref='OtherType' v-if='dislog.OtherType'></OtherType>其他信息 -->
            <CauseStepLog ref='CauseStepLog' :id='causeId' v-if='CauseStepStatus'></CauseStepLog><!--操作记录-->
            <!-- <partyPopUp ref='partyPopUp' :agencyList="agencyList"></partyPopUp>当事人信息修改或添加 -->
            <CasePopUp ref='CasePopUp' :cause_reason='cause_reason' :accuserList='LaysuitaccuserList' :i='i'
              :bankList="bankList">
            </CasePopUp><!--修改案件信息和添加-->
            <Compensation ref='Compensation' :i='i'></Compensation>
            <Other ref='Other' :info='OtherInfo' :see="see" :i=i :accuserList='accuserList'></Other>
            <!-- 延期记录 -->
            <InvalidTable ref='InvalidTable' v-if='$store.state.cause.id && hasjdList' :Step='hasjdList'></InvalidTable>
            <a-modal :visible="formVis" @cancel="formVis = false" title='延期天数' width='460px' @ok='visSub'>
              <a-row align='middle' justify='space-between' type='flex' style="margin-bottom:10px;">
                <label>延期天数：</label>
                <a-input placeholder='请输入延期天数' v-model='smlform.day' type='number' style="width:340px;"> </a-input>
              </a-row>
              <a-row align='middle' justify='space-between' type='flex'>
                <label>延期原因：</label>
                <a-input placeholder='请输入延期原因' v-model='smlform.reason' style="width:340px;"> </a-input>
              </a-row>
            </a-modal>
          </div>
          <div class="card">
            <div class="background extra">
              <div class="radio-inputs">
                <label class="radio" v-for='(item, index) in caselist' :key='item.id'>
                  <!-- <input type="radio" name="radio" :checked="index === selectedIndex"
                    @click="switchChange(item, index)" /> -->
                  <button :class="[index === selectedIndex ? 'titleButton' : 'selected']"
                    @click="switchChange(item, index)">
                    {{ item.cause_type == 1 ? `案件 ${item.sort} ( 诉讼 )` : `案件 ${item.sort} ( 仲裁 )` }}
                  </button>
                  <!-- <span class="name">
                    {{ item.cause_type == 1 ? `案件 ${item.sort} ( 诉讼 )` : `案件 ${item.sort} ( 仲裁 )` }}
                    <span v-if="index === selectedIndex" class="line-effect"></span>
                    <span v-if="index === selectedIndex" class="particle-top"></span>
                    <span v-if="index === selectedIndex" class="particle-bottom"></span>
                  </span> -->
                </label>
              </div>
              <div class="rt">
                <a-button icon="plus" @click='deAdd'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "cause:add") && debInfo.is_clear != 1'>新增</a-button>
                <a-button style="width: 120px;" icon="paper-clip" @click='seeFile(0)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:files")'>附件汇总 </a-button>
                <a-button style="width: 120px;" icon="file-protect" @click='seeCauseStepLog("CauseStepLog")'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:keep:index")'>操作记录 </a-button>
                <a-button @click='delsu(1)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "cause:invaild") && $store.state.cause.invaild != 1 && caselist.length > 0'>
                  作废
                </a-button>
                <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delsu(0)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "cause:delete") && debInfo.is_clear != 1 && caselist.length > 0'>
                  <a-button style="margin-right: 20px;">
                    删除
                  </a-button>
                </a-popconfirm>
              </div>
            </div>
            <div v-if="show">
              <div style="width:100%;overflow:hidden;"
                v-if='caselist.length > 0 && ($common.AccAUTH(i.accuser_id, $store.state.cause.invaild == 0 ? "cause:lists" : "cause:lists:invaild"))'>
                <div class="insetbox">
                  <div class="">
                    <div class="htit background" style="justify-content: start;gap: 20px;">
                      <div class="h2">当事人信息</div>
                      <a-button icon="plus" @click='handleUpdateUser({ see: false }); visibleShow("Other");'
                        v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:other:add") && debInfo.is_clear != 1'>添加</a-button>
                      <div>
                        <!-- <a-button type="primary" icon="plus" @click='deAdd'
                          v-if='$common.AccAUTH(debInfo.accuser_id, "cause:add") && debInfo.is_clear != 1'>添加</a-button> -->
                      </div>
                    </div>
                    <!-- 当事人信息 -->
                    <Basic class="background" :i="i" :info='LaysuitInfo' @update-user="handleUpdateUser"></Basic>
                    <!-- <div class="solids"></div> -->
                    <!-- <Agent class="background" :i=i :agent_model=agent_model></Agent> -->
                    <div class="solids"></div>
                    <CaseInformation class="background" :hasjdList="hasjdList" :i=i :index="index" :key="i.id"
                      :userLists="userLists">
                    </CaseInformation>
                    <div class="solids"></div>
                    <!-- <div class="htit" style="border:0 none;">
                      <div class="h3">
                        <div style="margin:0;font-size: 15px;">案件基础信息 -->
                    <!-- [{{ i.cause_type == 1 ? '诉讼' : '仲裁' }}] -->
                    <!-- <a-select style="min-width: 100px;" size="small" v-model="cause_type" placeholder="请选择"
                            class="nselect" @change='changeCause_type($event, i)'>
                            <a-select-option v-for="i in Cause_typelist" :key="i.id">{{ i.title }}</a-select-option>
                          </a-select> -->
                    <!-- </div> -->
                    <!-- <a-select style="min-width: 100px;" size="small" v-model="agent_model" placeholder="请选择"
                          class="nselect" @change='agCk($event, index)'
                          v-if='$store.state.user.id <= 1 || ($common.AccAUTH(i.accuser_id, "cause:agentModel:read") && debInfo.is_clear != 1 && $store.state.cause.invaild != 1)'
                          :disabled='!$common.AccAUTH(i.accuser_id, "caue:agentModel:edit")'>
                          <a-select-option v-for="i in agencyList" :key="i.id">{{ i.title }}</a-select-option>
                        </a-select> -->
                    <!-- <span style="margin-left:20px;">当前负责人:</span>
                        <a-select style="min-width: 120px;" size="small"
                          :value="i.step_user_id === 0 ? null : i.step_user_id" placeholder="当前负责人" class="nselect"
                          show-search option-filter-prop="children" :filter-option="filterOption"
                          @change="setStepUser($event, i)">
                          <a-select-option v-for="i in userList" :key="i.id">{{ i.uname }}</a-select-option>
                        </a-select> -->
                    <!-- </div>
                      <div class="rt">
                        <a-button v-if="i.has_loan" icon="money-collect" style="margin-right: 20px;"
                          @click="dbclick(i)">分期信息</a-button>
                        <a-button v-if="i.has_payee" icon="transaction" style="margin-right: 20px;"
                          @click="collectionClick(i)">案款信息</a-button>
                        <Share v-if='$common.AccAUTH(i.accuser_id, "Infomation:share")'></Share>
                        <a-button type="primary" ghost icon="edit" @click='LaysuitInfo = i; visibleShow("Laysuit");'
                          v-if='$store.state.user.id <= 1 || ($common.AccAUTH(i.accuser_id, "cause:edit") && debInfo.is_clear != 1 && $store.state.cause.invaild != 1)'>修改</a-button>
                      </div> -->
                    <!-- </div> -->
                    <!-- <CaseInfo v-if="$store.state.cause.id && comLoad" :i="i" :hasjdList="hasjdList" :index="index">
                    </CaseInfo> -->
                    <!-- <CaseInfo v-if="$store.state.cause.id && comLoad && (cause_type == 1 || cause_type == 2)" :i="i"
                      :hasjdList="hasjdList" :index="index">
                    </CaseInfo> -->
                    <justice v-if="cause_type == 3" :i="i" :hasjdList="hasjdList" :index="index">
                    </justice>
                    <execute v-if="cause_type == 4" :i="i" :hasjdList="hasjdList" :index="index">
                    </execute>
                  </div>
                  <!-- <div class="solids" style="margin-top:20px;"></div> -->
                  <div v-if="$store.state.cause.id && comLoad">
                    <!-- <OtherTypes :test_model=test_model></OtherTypes> -->
                    <!-- <div class="solids"></div> -->
                    <div class="card wbg" v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:index")'>
                      <CarList :byTypeObject=byTypeObject :iData="i" :List='debInfo.keep'></CarList> <!-- 财产信息 -->
                    </div>
                  </div>
                  <!-- <div class="solids" style="margin-top:20px;"></div> -->
                  <!-- 拍卖信息暂时隐藏 -->
                  <!-- <Auction
                    v-if="$store.state.cause.id && comLoad && $common.AccAUTH($store.state.cause.accuser.id, 'debinfo:auction:index')">
                  </Auction> -->
                  <!-- <div class="solids" style="margin-top:20px;"></div> -->
                  <div class="insetbox"
                    v-if='$common.AccAUTH(i.accuser_id, $store.state.cause.invaild != 1 ? "true" : "cancel.cause.communication.view")'>
                    <HisList class="background" :accuser_id="i.accuser_id" :is_clear="debInfo.is_clear"
                      v-if="i.accuser_id && $store.state.cause.id && comLoad"></HisList>
                  </div>
                  <div class="solids"></div>
                  <div class="insetbox jdmbox background"
                    v-if="$common.AccAUTH(i.accuser_id, $store.state.cause.invaild == 0 ? 'stepbar:lists' : 'cause:invaild:step:lists')">
                    <div class="htit hspan">
                      <div class="h2">案件进度
                      </div>
                      <div class="rt">
                        <a-button icon="plus" @click='visibleShow("stepbox")'
                          v-if='$common.AccAUTH(i.accuser_id, "cause:step:ja:add") || !$store.state.editJA'>添加进度</a-button>
                        <a-button @click='$refs.InvalidTable.visible = true;'
                          v-if='$store.state.cause.invaild != 1 && $common.AccAUTH(i.accuser_id, "step:delay:history")'>延期记录</a-button>
                      </div>
                    </div>
                    <a-row class="jindu">
                      <a-col :span='11'>
                        <div><span class="item">标准进度</span></div>
                      </a-col>
                      <a-col :span='13'>
                        <div><span :class="['item', arr.length > 0 ? '' : 'item-no']">特殊进度</span></div>
                      </a-col>
                    </a-row>
                    <div class="inboxset" v-if="cause_type == 1 || cause_type == 2">
                      <div class="stepbox" v-for='(i, index) in standardStep' :key='index'>
                        <div class="steps-item" :style="{ width: index == 0 ? '16.67%' : '' }" v-for='(j, ind) in i'
                          :key='ind'
                          :class='{ "over": j.isover, "ant-steps-item-wait": !j.isover, "no-after-line": index == 0 && ind == 1 }'
                          v-if="j.lite != 181">
                          <div class="tit"
                            :class="['beautycard', hasjdList.length > 0 && j.lite == hasjdList[hasjdList.length - 1].step ? 'commoncardActNow' : '']">
                            <div class="name">
                              {{ j.name }}
                              <span v-if='j.remind' v-html='rTime(j.remind)'></span>
                            </div>
                            <div class="time">{{ j.time | yearFormats }}</div>
                            <a href='javascript:void(0);' v-if='j.isover'
                              @click='seeStep(j.element, j.lite, j.keyName, j)'>查看</a>
                            <a-popover :mouseEnterDelay="0.5" title="延期记录" v-if='j.remind'>
                              <template slot="content">
                                <div class="table stepsTable" style="max-height: 500px;overflow-y: auto;">
                                  <table>
                                    <thead>
                                      <td>原延期日期</td>
                                      <td>现延期日期</td>
                                      <td>延期理由</td>
                                    </thead>
                                    <tbody>
                                      <tr v-for='(k, n) in j.remind.over_comment' :key="n">
                                        <td>{{ k.originDate }}</td>
                                        <td>{{ k.overDate | yearFormats }}</td>
                                        <td>
                                          <Tooltip :tit='k.reason'></Tooltip>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </template>
                              <a href='javascript:void(0);' style="margin-left:10px;"
                                @click='smlform.id = j.remind.id; smlform.day = null; smlform.reason = null; formVis = true;'
                                v-if='$store.state.cause.invaild == 0 && $common.AccAUTH($store.state.cause.accuser.id, j.keyName + ":delayed") && !$store.state.editJA'>延期</a>
                            </a-popover>
                          </div>
                        </div>
                        <div v-if="index == 0" class="special-module">
                          <div
                            :class="['commoncard', hasjdList.length > 0 && row.lite == hasjdList[hasjdList.length - 1].lite ? 'commoncardActNow' : row.isover ? 'commoncardAct' : '']"
                            v-for="(row, index) in arr" :key="index">
                            <!-- <div class="name">{{ row.name }}<span v-if='row.remind' v-html='
                              (row.remind)'></span></div>
                          <div class="date">{{ row.time | yearFormats }}</div>
                          <a href='javascript:void(0);' v-if='row.isover'
                              @click='seeStep(row.element, row.lite, row.keyName, row)'>查看</a> -->
                            <div class="name">{{ row.name }}
                              <span v-if='row.remind' v-html='rTime(row.remind)'></span>
                            </div>
                            <div class="date">{{ row.time | yearFormats }}</div>
                            <div class="alink">
                              <a href='javascript:void(0);'
                                @click='seeStep(row.element, row.lite, row.keyName, row)'>查看</a>
                              <a-popover :mouseEnterDelay="0.5" title="延期记录" v-if='row.remind.id'>
                                <template slot="content">
                                  <div class="table stepsTable" style="max-height: 500px;overflow-y: auto;">
                                    <table>
                                      <thead>
                                        <td>原延期日期</td>
                                        <td>现延期日期</td>
                                        <td>延期理由</td>
                                      </thead>
                                      <tbody>
                                        <tr v-for='(k, n) in row.remind.over_comment' :key="n">
                                          <td>{{ k.originDate }}</td>
                                          <td>{{ k.overDate | yearFormats }}</td>
                                          <td>
                                            <Tooltip :tit='k.reason'></Tooltip>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </template>
                                <a href='javascript:void(0);' style="margin-left:10px;"
                                  @click='smlform.id = row.remind.id; smlform.day = null; smlform.reason = null; formVis = true;'
                                  v-if='$store.state.cause.invaild == 0 && $common.AccAUTH($store.state.cause.accuser.id, row.keyName + ":delayed") && !$store.state.editJA'>延期</a>
                              </a-popover>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 公证//改完要删除 -->
                    <div class="inboxset" v-if="cause_type == 3">
                      <div class="stepbox" v-for='(i, index) in justice' :key='index'>
                        <div class="steps-item" v-for='(j, ind) in i' :key='ind'
                          :class='{ "over": j.isover, "ant-steps-item-wait": !j.isover }' v-if="j.lite != 181">
                          <div class="tit" :style='{ "margin-left": pxDw(j.name) + "px" }'>
                            <div class="name">
                              {{ j.name }}
                              <span v-if='j.remind' v-html='rTime(j.remind)'></span>
                            </div>
                            <div class="time">{{ j.time | yearFormats }}</div>
                            <a href='javascript:void(0);' v-if='j.isover'
                              @click='seeStep(j.element, j.lite, j.keyName, j)'>查看</a>

                            <a-popover :mouseEnterDelay="0.5" title="延期记录" v-if='j.remind'>
                              <template slot="content">
                                <div class="table stepsTable" style="max-height: 500px;overflow-y: auto;">
                                  <table>
                                    <thead>
                                      <td>原延期日期</td>
                                      <td>现延期日期</td>
                                      <td>延期理由</td>
                                    </thead>
                                    <tbody>
                                      <tr v-for='k in j.remind.over_comment'>
                                        <td>{{ k.originDate }}</td>
                                        <td>{{ k.overDate | yearFormats }}</td>
                                        <td>
                                          <Tooltip :tit='k.reason'></Tooltip>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </template>
                              <a href='javascript:void(0);' style="margin-left:10px;"
                                @click='smlform.id = j.remind.id; smlform.day = null; smlform.reason = null; formVis = true;'
                                v-if='$store.state.cause.invaild == 0 && $common.AccAUTH($store.state.cause.accuser.id, j.keyName + ":delayed") && !$store.state.editJA'>延期</a>
                            </a-popover>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 调节//改完要删除 -->
                    <div class="inboxset" v-if="cause_type == 4">
                      <div class="stepbox" v-for='(i, index) in execute' :key='index'>
                        <div class="steps-item" v-for='(j, ind) in i' :key='ind'
                          :class='{ "over": j.isover, "ant-steps-item-wait": !j.isover }' v-if="j.lite != 181">
                          <div class="tit" :style='{ "margin-left": pxDw(j.name) + "px" }'>
                            <div class="name">
                              {{ j.name }}
                              <span v-if='j.remind' v-html='rTime(j.remind)'></span>
                            </div>
                            <div class="time">{{ j.time | yearFormats }}</div>
                            <a href='javascript:void(0);' v-if='j.isover'
                              @click='seeStep(j.element, j.lite, j.keyName, j)'>查看</a>
                            <!-- :overlayStyle="{
                            maxHeight: '500px',
                            overflow: 'auto'
                            }" -->
                            <a-popover :mouseEnterDelay="0.5" title="延期记录" v-if='j.remind'>
                              <template slot="content">
                                <div class="table stepsTable" style="max-height: 500px;overflow-y: auto;">
                                  <table>
                                    <thead>
                                      <td>原延期日期</td>
                                      <td>现延期日期</td>
                                      <td>延期理由</td>
                                    </thead>
                                    <tbody>
                                      <tr v-for='k in j.remind.over_comment'>
                                        <td>{{ k.originDate }}</td>
                                        <td>{{ k.overDate | yearFormats }}</td>
                                        <td>
                                          <Tooltip :tit='k.reason'></Tooltip>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </template>
                              <a href='javascript:void(0);' style="margin-left:10px;"
                                @click='smlform.id = j.remind.id; smlform.day = null; smlform.reason = null; formVis = true;'
                                v-if='$store.state.cause.invaild == 0 && $common.AccAUTH($store.state.cause.accuser.id, j.keyName + ":delayed") && !$store.state.editJA'>延期</a>
                            </a-popover>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="solids"></div>
                  <div class="incbox background" v-if='causeId && !loading'>
                    <div class="smlbox" v-if='credit && $common.AccAUTH(i.accuser_id, "dktFee:do")'>
                      <Count :Proposition='credit' title='主张债权及费用计算' :type='false' :payee='i.payee'
                        :seeCapital='Number(i.capital) || 0' :used_fee="i.used_fee"
                        @resh='init($store.state.cause.id, "resh")'>
                      </Count>
                    </div>
                    <div class="smlbox"
                      v-if='Postcredit && credit && $common.AccAUTH(i.accuser_id, "cause:credit:lists")'>
                      <Count :type='true' title='确认债权及费用计算' :Proposition='Postcredit' :Credit='credit'
                        :payeeFee="i.payee_fee" @resh='init($store.state.cause.id, "resh")'
                        :seeCapital='Number(i.capital) || 0' :used_fee="i.used_fee" :bankFee="i.bank_clear_fee"></Count>
                    </div>
                  </div>
                  <!-- <div class="solids"></div> 
                  <Out class="background" :Proposition='credit' :outList="outList"
                    v-if="outList.length && credit && $common.AccAUTH(i.accuser_id, 'return:read')"></Out> -->

                </div>
              </div>
            </div>
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
import { dateFormat } from "@/assets/js/formData"
import { mapGetters, mapActions } from 'vuex'
import { debtorDel } from '@/server/debtor'
import { causeStep, stepCredit, debtorClear, delCause, Delay, refundList, getby_type, reasonList, debtorAll, getAccuserAll } from "@/server/api"
import { accUserList, causeStStepUser } from '@/server/user'
import { agencyList, by_type } from '@/server/directory'
import paymentCard from './dislog/paymentCard.vue'
import cmps from './reg'
import Step from "./step.json"      //进度json
import artStep from "./artStep.json"      //进度json
import Proposition from "./stepCredit.json"     //债券列表
import { Tacitly } from "@/assets/js/Tacitly"
import justice from "./justice.json"      //进度json测试//改完要删除
import execute from "./execute.json"      //进度json测试//改完要删除
export default {
  components: {
    ...cmps, paymentCard
  },
  data() {
    return {
      selectedIndex: 0,
      cause_type: 1,
      userList: [],    //用户列表
      agencyList: [],
      testlist: [
        {
          id: 1,
          title: '金融借款'
        }, {
          id: 2,
          title: '担保追偿'
        }, {
          id: 3,
          title: '融资租赁'
        }
      ],
      test_model: 1,
      agent_model: '',
      formVis: false,
      outList: [],
      causeId: null,
      FileType: 0,   //0 普通附件 1沟通记录附件
      smlform: {
        day: '',
        reason: ''
      },
      Cause_typelist: [{
        id: 1,
        title: '诉讼'
      }, {
        id: 2,
        title: '仲裁',
      }, {
        id: 3,
        title: '公证'
      }, {
        id: 4,
        title: '调解'
      }],
      list: [
        {
          id: 1,
          title: '金融借款'
        }, {
          id: 2,
          title: '担保追偿'
        }, {
          id: 3,
          title: '融资租赁'
        }
      ],
      // isAllDis: this.$route.query.t,
      OtherInfo: {}, //单个关联被告详情
      loading: true,      //加载
      hasjdList: [],
      Step: {},
      standardStep: {},
      execute: {},
      justice: {},
      comLoad: false,
      credit: null,        //主张债权
      Postcredit: null,
      LaysuitInfo: {}, //当前案件
      arr: [],
      i: {},
      index: 0,
      show: false,
      info: {},
      byTypeObject: {},
      remind: { over_date: '2025-01-01' },
      cause_reason: [],
      reasonData: {
        limit: 50,
        page: 1,
        title: null,
      },
      debtorAll: [],
      see: false,
      accuserList: [],
      agentmodelList: [],
      costmodelList: [],
      alldefendantList: [],
      preservates: {},
      LaysuitaccuserList: [],
      bankList: [],
      userLists: {},
      CauseStepStatus: false,
    }
  },
  computed: {
    time() {
      return dateFormat(new Date())
    },
    ...mapGetters([
      'caselist',        //案件列表
      'debInfo',
      'dislog',
      'APIKEY',
    ]),
    listName() {
      const item = this.list.find(e => e.id == this.debInfo.car_type_id)
      return item ? item.title : ''
    },
  },
  watch: {
    caselist: {
      deep: true,
      handler() {
        if (this.i.id) {
          this.init(this.i.id)
        }
      },
    }
  },
  beforeDestroy() {
    document.title = `${Tacitly.name}案件管理系统`
  },
  async created() {
    // console.log('store', this.$store.state);
    await this.$store.dispatch("Users/getUserlist");
    this.userLists = this.$store.state.Users.userLists
    this.getList({ "debtor_id": this.$route.params.id }).then(e => {
      let path = this.$route.path

      if (path.substring(0, path.lastIndexOf('/')) === '/ly/details') {
        const namePart = this.debInfo.realname ? `${this.debInfo.realname} - ` : '';
        document.title = `${namePart}${Tacitly.name}案件管理系统`;

      }
      if (e.length > 0) {
        //this.$store.dispatch("setkey", { key: "cause", value: e[0] })
        const sort = this.$route.query.e * 1 - 1 || 0
        this.causeId = e[sort].id
        this.causeIndex = e.list
        const existIds = new Map();
        e.forEach(ele => {
          const defendants = ele.parties.defendant || [];
          defendants.forEach(item => {
            const id = item.chinaid;
            if (!id) return;
            existIds.set(id, item); // 覆盖，保留最后一个
          });
        });
        this.alldefendantList = Array.from(existIds.values());
        this.Postcredit = this.rPropo(e[sort].credit)
        this.init(e[sort].id)  // e[sort].id为进度id
        // this.getCredit(e[sort].id)
      } else {
        this.loading = false;
      }
    })
    this.getInfo({          //
      "id": this.$route.params.id
    })
    getby_type({
      type: `agent${','}preservation_status${','}car_status${','}agent_model${','}cost_model`
    }).then(res => {
      this.byTypeObject = res
      this.agentmodelList = res.agent_model
      this.costmodelList = res.cost_model
      this.preservates = { agent_model: this.agentmodelList, cost_model: this.costmodelList }
    })
    getAccuserAll().then((res) => {//原告信息
      this.accuserList = res.debtor_list
      const uniqueLast = [...new Map([...res.accuser_list].reverse().map(item => [item.id, item])).values()]
      this.LaysuitaccuserList = uniqueLast
    }),
      this.causeList()

    await this.$store.dispatch("Case/getBanklist");
  },
  filters: {
    add() {
      this.info = {
        item_type: null,
        auction_status: 1,
        files: []
      }
      this.$refs.dislog.edit = 1
      this.$refs.dislog.visible = true
    },
    nAccId() {
      return this.$store.state.cause.accuser_id || this.debInfo.id
    },
    rStatus(val) {
      let keyjson = { 1: "待审核", 2: "审核通过", 3: "审核拒绝" }
      return keyjson[val]
    }
  },
  methods: {
    getBytype(type) {
      by_type({ type: type }).then(res => {
        this.agentmodelList = res.agent_model
        this.costmodelList = res.cost_model
      })
    },
    handleUpdateUser(newData) {
      this.see = newData.see
      this.OtherInfo = newData
    },
    async causeList() {//案由
      const list = JSON.parse(localStorage.getItem('reasonlist'))
      this.cause_reason = list
    },
    switchChange(e, index) {
      if(this.selectedIndex == index) return 
      this.selectedIndex = index;
      this.i = e;
      this.index = index
      this.causeId = e.id
      this.show = false
      this.init(e.id)
    },
    changeCause_type(e, i) {
      i.cause_type = e
    },
    seeFile(type) {
      this.FileType = type
      this.visibleShow("filelist")
    },
    // setStepUser(value, item) {
    //   item.step_user_id = value || 0;
    //   causeStStepUser({ cause_id: item.id, user_id: item.step_user_id }).then(e => {
    //     this.$message.success({ content: '设置成功', key: 'updatable' });
    //   })
    // },
    // filterOption(input, option) {
    //   return (
    //     option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    //   );
    // },
    visSub() {
      Delay(this.smlform).then(e => {
        this.$message.success({ content: '延期操作已提交，待审核', key: 'updatable' });
        this.init(this.$store.state.cause.id)
        this.formVis = false;
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    rTime(val) {
      let fYear = (v) => {
        let days = v ? new Date(v).toLocaleDateString() : new Date().toLocaleDateString()
        return new Date(days).getTime()
      }
      if (val.over_date) {
        const today = fYear(),
          vTime = fYear(val.over_date);
        if (today >= vTime) {
          const day = parseInt((today - vTime) / 3600000 / 24)
          return `(<font color='#f00'> ${day + val.day}</font> / ${val.day} )`
        } else {
          const day = parseInt((vTime - today) / 3600000 / 24);
          let newDate = val.day - day
          return `(${newDate <= 0 ? 0 : newDate}/${val.day})`
        }
      } else {
        return ''
      }
    },
    // dbclick(record) {
    //   if (this.$common.AUTH('loan:info:lists')) {
    //     let routeUrl = this.$router.resolve({ "name": "paybacksee", params: { "id": record.accused[0].id } });
    //     window.open(routeUrl.href, '_blank');
    //   }
    //   else {
    //     this.$message.error({ content: '暂无权限', key: 'updatable' });
    //   }
    // },
    // collectionClick(record) {
    //   if (this.$common.AUTH('payee:info:lists')) {
    //     let routeUrl = this.$router.resolve({ "name": "AmountSee", params: { "id": record.accused[0].id } });
    //     window.open(routeUrl.href, '_blank');
    //   }
    //   else {
    //     this.$message.error({ content: '暂无权限', key: 'updatable' });
    //   }
    // },
    debDel(id) {
      this.$modal.confirm({
        title: '确认删除此案件?',
        onOk: () => {
          debtorDel({ debtor_id: id }).then(e => {
            this.$message.success({ content: '删除' });
            this.$router.push({ name: 'newlylist' });
            // this.$router.back(-1)
          })
        }
      });
    },
    pxDw(unit) {
      let len = unit.length;
      const l = [0, 0, 30, 22, 14, 8, 2, 0, 0, 0, 0, 0]
      if (unit == "重审立案") return 0
      else return l[len]
    },
    deAdd() {
      this.bankList = this.$store.state.Case.bankList
      let casev = JSON.parse(JSON.stringify(this.caselist))
      const keys = ['accuser_id', 'team_id', 'chinaid', 'debtor_ids', 'court', 'court_id', 'bank_id']
      let info = casev.length > 0 ? casev[casev.length - 1] : { accused: [] }
      info.accuser_id = null
      info.id = null
      this.LaysuitInfo = info
      this.visibleShow("Laysuit")
    },
    delsu(type) {
      const id = this.$store.state.cause.id
      if (type == 0) {
        delCause({ cause_id: id }).then(res => {
          this.$message.success({ content: '已删除', key: 'updatable' });
          setTimeout(e => {
            if (res.cause_count > 0) {
              window.history.go(0)
            } else {
              this.$router.push({ name: 'newlylist' })
            }
          }, 1000)
        })
      } else {
        this.visibleShow("reason")
      }
    },
    rPropo(Arr) {
      let newArr = []
      Object.keys(Proposition).map(item => {
        let isInclude = Arr.some(it => {
          return it.type == item
        })
        if (isInclude == false) {
          newArr.push({
            type_title: Proposition[item],
            type: item * 1,
            fee: 0
          })
        } else {
          newArr.push(Arr.filter(ele => { return ele.type == item })[0])
        }
      })
      return newArr
    },
    async postMain(id, resh) {
      if (resh) {
        this.getList({
          "debtor_id": this.$route.params.id
        }).then(e => {
          if (e.length > 0) {
            let credit = e.filter(ele => { return ele.id == id })[0].credit
            this.Postcredit = this.rPropo(credit)
          } else {
            this.loading = false;
          }
        })
      } else {
        let credit = this.caselist.filter(ele => { return ele.id == id })[0].credit
        this.Postcredit = this.rPropo(credit)
      }
    },
    clearP() {
      this.$store.dispatch('setkey', { key: 'StepLite', value: 181 })
      this.$store.dispatch('setkey', { key: 'StepKey', value: 'audit:debtorClear' })
      this.$store.dispatch("setkey", { key: "Edit", value: this.debInfo.clear });
      this.visibleShow("Fiveteen")
    },
    textagCk(e) {
    },
    agCk(val, index) {
      if (this.$store.state.user.id <= 1 || (this.$common.AccAUTH(this.$store.state.cause.accuser.id, "caue:agentModel:edit") && this.debInfo.is_clear != 1 && this.$store.state.cause.invaild != 1)) {
        this.loading = true;
        this.$Ajax({
          url: "cause/editAgentModel",      //url 
          type: "put",
          data: { id: this.$store.state.cause.id, agent_model: val },
          success: (e) => {
            this.$message.success('修改成功')
            this.$store.dispatch('Case/putInData', { index: index, key: "agent_model", value: val })
            this.loading = false
          },
          fail: (e) => {
            this.loading = false
          }
        })
      } else {
        this.$message.error('暂无权限')
      }
    },
    async init(id, resh, causeType) {
      const cause = this.caselist.filter(ele => { return ele.id == id })[0]
      if (cause) {
        this.i = { ...cause }
        if (this.i.step_user_id == 0) {
          this.i.step_user_id = null
        }
      }
      this.comLoad = false;
      await this.postMain(id, resh)
      this.causeId = null
      this.comType = 1;
      await causeStep({ cause_id: id }).then(e => {
        this.show = true     //进度
        this.$store.dispatch("setkey", { key: "cause", value: cause })
        const stepJSON = cause.cause_type == 1 ? Step : artStep;
        let StepList = JSON.parse(JSON.stringify(stepJSON))
        for (let val in StepList) {
          StepList[val].map(element => {
            e.list.map(ele => {
              if (element.lite * 1 == ele.step) {
                element.isover = true;
                element.time = ele.create_time
                element.remind = ele.remind.over_date ? ele.remind : null
              }
            })
          })
        }

        let executeList = JSON.parse(JSON.stringify(execute))//改完要删除
        for (let val in executeList) {
          executeList[val].map(element => {
            e.list.map(ele => {
              if (element.lite * 1 == ele.step) {
                element.isover = true;
                element.time = ele.create_time
                element.remind = ele.remind.over_date ? ele.remind : null
              }
            })
          })
        }

        let justiceList = JSON.parse(JSON.stringify(justice))//改完要删除
        for (let val in justiceList) {
          justiceList[val].map(element => {
            e.list.map(ele => {
              if (element.lite * 1 == ele.step) {
                element.isover = true;
                element.time = ele.create_time
                element.remind = ele.remind.over_date ? ele.remind : null
              }
            })
          })
        }

        let noverjA = e.list.filter(ele => {
          return ele.step == 180
        })
        this.$store.dispatch("setkey", { key: "editJA", value: noverjA.length >= 1 && this.$store.state.user.id > 1 })
        this.agencyList.map(item => {
          if (item.id == cause.agent_model) {
            this.agent_model = item.title
          }
        })

        this.hasjdList = e.list ? e.list : [];
        // const invaild = cause.invaild;
        // this.$store.dispatch("Debinfo/SetClear", invaild)
        this.Step = StepList;
        const datas = e.list.filter(item => item.special == 2)
        datas.forEach(element => {
          const matchEle = this.Step[7] ? this.Step[7].find(ele => {
            return element.title === ele.name;
          }) : [];
          if (matchEle) {
            element.isover = true;
            element.keyName = matchEle.keyName;
            element.name = matchEle.name;
            element.time = element.create_time;
            element.lite = element.step
            element.element = matchEle.element
          }
        });
        this.arr = datas
        const { 7: del, ...newData } = StepList;
        this.standardStep = newData
        this.execute = executeList;//改完要删除
        this.justice = justiceList;//改完要删除
        this.causeId = id;
        this.loading = false;
        this.comLoad = true
      })
      this.credit = null;
      await stepCredit({ cause_id: id }).then(e => {
        this.credit = this.rPropo(e.list)
        this.loading = false;
      })
      // const isValidDate = (date) => {
      //   return date instanceof Date && !isNaN(date.getTime())
      // }
      // await refundList({ cause_id: id }).then(res => {//以前的退费数据来源，暂时废弃
      //   const list = res.list.length > 0 ? res.list.map(ele => {
      //     return {
      //       type: ele.type,
      //       fee: ele.fee / 100,
      //       time: ele.time,
      //       files: ele.files,
      //       comment: ele.comment,
      //       audit: ele.audit.length > 0,
      //       filesobj: {
      //         id: ele.files,
      //         origin_name: ele.file_origin_name,
      //         url: ele.file_url
      //       }
      //     }
      //   }) : [
      //     { "type": 1, "fee": '', "time": null, "files": "", "filesobj": {}, comment: "", audit: false },
      //     { "type": 2, "fee": '', "time": null, "files": "", "filesobj": {}, comment: "", audit: false },
      //     { "type": 3, "fee": '', "time": null, "files": "", "filesobj": {}, comment: "", audit: false }
      //   ]
      //   const rr = new Map()
      //   const rlist = list.filter((a) => !rr.has(a.type) && rr.set(a.type, 1))
      //   this.outList = rlist;
      // })
    },
    // async getCredit(id) {
    //   await stepCredit({ cause_id: id }).then(e => {
    //     this.credit = this.rPropo(this.hasjdList)
    //     this.loading = false;
    //   })
    // },
    ...mapActions({
      getList: 'Case/getlist',
      getInfo: 'Debinfo/getInfo'
    }),
    seeStep(name, lite, keyName) {
      this.$store.dispatch("setkey", { key: "Edit", value: true })
      this.setStep(lite, keyName)
      setTimeout(e => {
        if (this.$common.AccAUTH(this.debInfo.accuser_id, this.$store.state.cause.invaild == 0 ? this.$store.getters.stepPower.see : 'cause:invaild:step:lists')) {
          this.visibleShow(name)
        }
        else {
          this.$message.error('暂无权限')
        }
      }, 200)

    },
    setStep(lite, keyName) {
      this.$store.dispatch("setkey", { key: "StepLite", value: lite })
      this.$store.dispatch("setkey", { key: "StepKey", value: keyName })
    },
    visibleShow(name) {
      this.$store.dispatch("openkey", { key: name, by: true })
    },
    seeCauseStepLog(name) {
      this.CauseStepStatus = true
      this.$store.dispatch("openkey", { key: name, by: true })
    }
  }
}
</script>
<style lang="less" scoped>
.tab-wrap {
  .ant-tabs-bar {
    margin-left: 20px;
  }
}

.ant-tabs-nav-container {
  font-size: 15px;
}

.tag {
  color: #1890ff;
  font-weight: 600;
  border: 1px solid #1890ff;
  border-radius: 4px;
  padding: 0 5px;
  font-size: 13px;
}

.ising {
  opacity: 0.3;
}

.special-module {
  display: flex;
  flex-wrap: nowrap;
}

.rt {
  display: flex;
  gap: 10px;
}

@import './index.less';

.radio-inputs {
  position: relative;
  z-index: 99;
  display: flex;
  // flex-wrap: wrap;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 20px;
  font-size: 15px;
  height: 60px;
  align-content: center;
  gap: 15px;
  font-weight: 500;
  width: 1167px;
}

.radio-inputs .radio {
  width: 8.875em;
  display: flex;
  align-items: center;
  justify-content: center;
}

.radio-inputs .radio input {
  display: none;
}

.radio-inputs .radio .name {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0.4rem 0;
  color: rgb(66, 66, 66);
  transition: all 0.15s ease-in-out;
  position: relative;
  width: 100%;
}

.radio-inputs .radio input:checked+.name {
  font-weight: bold;
}

/* Hover effect */
.radio-inputs .radio:hover .name {
  transform: translateY(-2px);
  color: #1890ff;
  font-weight: bold;
}

/* Animation */
.radio-inputs .radio input:checked+.name {
  position: relative;
  // animation: select 0.3s ease;
  color: #ffffff;
  /* 移除border-bottom */
  border-bottom: none;
  background: #1890ff;
  border-radius: 4px;
}

@keyframes select {
  0% {
    transform: scale(0.95);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

.extra {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #efefef;
  height: 60px;
}

/* 渐变色下划线 - 从中间向两端展开 */
.radio-inputs .radio input:checked+.name .line-effect {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 3px;
  background: linear-gradient(90deg,
      transparent 0%,

      #f7f7f7 10%,
      rgba(24, 144, 255, 0.2) 30%,

      rgba(24, 144, 255, 0.2) 70%,
      #ffffff 90%,
      transparent 100%);
  border-radius: 4px;
  opacity: 0;
  animation: expandLine 0.5s cubic-bezier(0.23, 1, 0.32, 1) forwards;
  transform: translateX(-50%);
  z-index: 1;
  pointer-events: none;

}

/* 从中间向两端展开的动画 */
@keyframes expandLine {
  0% {
    width: 0;
    opacity: 0;
  }

  30% {
    opacity: 0.8;
    width: 60%;
  }

  80% {
    width: 80%;
  }

  100% {
    width: 100%;
    opacity: 1;
  }
}

/* 上粒子 - 完全保持原样 */
.radio-inputs .radio input:checked+.name .particle-top {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #ffffff;
  opacity: 0;
  animation: particleUp 0.5s ease forwards;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.8);
  z-index: 2;
  pointer-events: none;
}

/* 下粒子 - 完全保持原样 */
.radio-inputs .radio input:checked+.name .particle-bottom {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #ffffff;
  opacity: 0;
  animation: particleDown 0.5s ease forwards;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 6px rgba(59, 130, 246, 0.8);
  z-index: 2;
  pointer-events: none;
}

/* 上粒子动画 */
@keyframes particleUp {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(0) scale(1);
  }

  50% {
    opacity: 1;
    transform: translateX(-50%) translateY(-5px) scale(1.2);
  }

  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px) scale(0.6);
  }
}

/* 下粒子动画 */
@keyframes particleDown {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(0) scale(1);
  }

  50% {
    opacity: 1;
    transform: translateX(-50%) translateY(5px) scale(1.2);
  }

  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(10px) scale(0.6);
  }
}



.titleButton {
  position: relative;
  padding: 0.35rem 0.55rem;
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.1), 0 18px 35px rgba(0, 0, 0, 0.15);
  background-color: #1890ff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffff;
  font-weight: bold;
  border: 3px solid #1890ff;
  overflow: hidden;
  font-size: 15px;
}

.selected {
  transition: all 0.2s ease;
  padding-block: 0.35rem;
  padding-inline: 0.55rem;
  background-color: #f7f7f8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #188fffea;
  position: relative;
  font-weight: bold;
  overflow: hidden;
  border: 1px solid #188fff6c;
}

.selected:hover {
  transform: scale(1.03);
  border: 2px solid;
}

.selected:active {
  // box-shadow: 4px 4px 12px #188fffea, -4px -4px 12px #188fffea;
}
</style>